export default "__VITE_ASSET__D6sO80I9__"